// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-question textarea {
    border: none;
    width: 100%;
    resize: none;
    padding: 10px;
    box-sizing: border-box;
    height: 150px;
    font-family: inherit;
    font-size: 16px;
    line-height: 20px;
    display: block;
    border-radius: var(--survey-input-border-radius, 2px);
    outline-offset: -1px;
}

.text-question .secure-text-entry {
    font-family: text-security-disc;
}

.text-question.text-question-v2 textarea {
    border: var(--v2-input-border);
    border-radius: 6px;
    padding: 12px 16px;
}

.text-question.text-question-v2 textarea::placeholder {
    color: var(--survey-placeholder-color);

    /* Firefox */
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Questions/TextQuestion/TextQuestion.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;;IAEtC,YAAY;IACZ,UAAU;AACd","sourcesContent":[".text-question textarea {\n    border: none;\n    width: 100%;\n    resize: none;\n    padding: 10px;\n    box-sizing: border-box;\n    height: 150px;\n    font-family: inherit;\n    font-size: 16px;\n    line-height: 20px;\n    display: block;\n    border-radius: var(--survey-input-border-radius, 2px);\n    outline-offset: -1px;\n}\n\n.text-question .secure-text-entry {\n    font-family: text-security-disc;\n}\n\n.text-question.text-question-v2 textarea {\n    border: var(--v2-input-border);\n    border-radius: 6px;\n    padding: 12px 16px;\n}\n\n.text-question.text-question-v2 textarea::placeholder {\n    color: var(--survey-placeholder-color);\n\n    /* Firefox */\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
